/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

window.myFunction = function(idrand, exsource_url, exsource, selectedoption) {
	document.getElementById(idrand).innerHTML = '<iframe class="zhaw-twoclick-iframe" src="' + exsource_url + '" title="" allow="accelerometer; autoplay *; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
}
window.changeImage = function(idrand, exsource_url, exsource, selectedoption, overlay, overlayalt, playbutton) {
		var image = overlay;
		var button = playbutton;
		var alt = overlayalt;
		var html = '';
			html = html + '<img src="' + image + '" alt="' + alt + '" onclick="myFunction(\'' + idrand + '\', \'' + exsource_url + '\', \'' + exsource + '\', \'' + selectedoption + '\')" width="100%">';
			html = html + '<img src="' + button + '" alt="Playbutton: ' + alt + '" onClick="myFunction(\'' + idrand + '\', \'' + exsource_url + '\', \'' + exsource + '\', \'' + selectedoption + '\')" class="playbutton">';
			html = html + '';
		document.getElementById(idrand).innerHTML = html;
}

/* eslint-disable no-console */
/* console.log( 'Hello World! (from create-block-zhaw-twoclick block)' ); */
/* eslint-enable no-console */

